export default __webpack_public_path__ + "static/media/ringing.de981457.mp3";